import { createSlice } from "@reduxjs/toolkit";

export const lookupsSlice = createSlice({
  name: "lookups",
  initialState: {
    cities: [],
    areas: [],
    carMakes: [],
    carTypes: [],
    carModels: [],
    stations: [],
    teams: {
      list: [],
      lastPageCount: 0,
    },
    drivers: {
      list: [],
      lastPageCount: 0,
    },
    levels: [],
    maintenanceTypes: [],
    verificationRequestsRejectionReasons: [],
    challengeSignalTypes: [],
  },
  reducers: {
    getCitiesRequest: () => {},
    getCitiesResponse: (state, action) => {
      state.cities = action.payload;
    },
    getAreasRequest: () => {},
    getAreasResponse: (state, action) => {
      state.areas = action.payload;
    },
    getCarMakesRequest: () => {},
    getCarMakesResponse: (state, action) => {
      state.carMakes = action.payload;
    },
    getCarTypesRequest: () => {},
    getCarTypesResponse: (state, action) => {
      state.carTypes = action.payload;
    },
    getCarModelsRequest: () => {},
    getCarModelsResponse: (state, action) => {
      state.carModels = action.payload;
    },
    getStationsRequest: () => {},
    getStationsResponse: (state, action) => {
      state.stations = action.payload;
    },
    getTeamsRequest: () => {},
    getTeamsResponse: (state, action) => {
      state.teams.list =
        action.payload.page === 1
          ? action.payload.teams
          : [...state.teams.list, ...action.payload.teams];
      state.teams.lastPageCount = action.payload.lastPageCount;
    },
    getDriversRequest: () => {},
    getDriversResponse: (state, action) => {
      state.drivers.list =
        action.payload.page === 1
          ? action.payload.drivers
          : [...state.drivers.list, ...action.payload.drivers];
      state.drivers.lastPageCount = action.payload.lastPageCount;
    },
    getLevelsRequest: () => {},
    getLevelsResponse: (state, action) => {
      state.levels = action.payload;
    },
    getMaintenanceTypesRequest: () => {},
    getMaintenanceTypesResponse: (state, action) => {
      state.maintenanceTypes = action.payload;
    },
    getVerificationRequestsRejectionReasonsRequest: () => {},
    getVerificationRequestsRejectionReasonsResponse: (state, action) => {
      state.verificationRequestsRejectionReasons = action.payload;
    },
    getChallengeSignalTypesRequest: () => {},
    getChallengeSignalTypesResponse: (state, action) => {
      state.challengeSignalTypes = action.payload;
    },
  },
});

export const {
  getCitiesRequest,
  getCitiesResponse,
  getAreasRequest,
  getAreasResponse,
  getCarMakesRequest,
  getCarMakesResponse,
  getCarModelsRequest,
  getCarModelsResponse,
  getStationsRequest,
  getStationsResponse,
  getTeamsRequest,
  getTeamsResponse,
  getDriversRequest,
  getDriversResponse,
  getLevelsRequest,
  getLevelsResponse,
  getMaintenanceTypesRequest,
  getMaintenanceTypesResponse,
  getVerificationRequestsRejectionReasonsRequest,
  getVerificationRequestsRejectionReasonsResponse,
  getChallengeSignalTypesRequest,
  getChallengeSignalTypesResponse,
  getCarTypesRequest,
  getCarTypesResponse,
} = lookupsSlice.actions;
export default lookupsSlice.reducer;
